/**
 * Peregre Works social media links.
 */
 export const SocialMediaLinks = {
    instagramUrl: 'https://www.instagram.com/peregreworks/',
    facebookUrl: 'https://www.facebook.com/peregreworks',
    youtubeUrl: 'https://www.youtube.com/channel/UCgki_iJZ4GJtrrZvdhH08mQ'
}